export type ConnectionQuality = "otima" | "instavel" | "lenta";
export type ServerHealth = "Normal" | "Degraded" | "Down";

export interface ConnectionMetrics {
  latencyMs: number;
  jitterMs: number;
  downloadMbps: number;
  uploadMbps: number;
}

const THRESHOLDS = {
  downloadOtimaMinMbps: 15,
  downloadLentaMaxMbps: 5,
  jitterOtimaMaxMs: 120,
  latencyLentaMinMs: 1000,
};

export function classificarConexao(metrics: ConnectionMetrics): ConnectionQuality {
  const lenta =
    metrics.downloadMbps <= THRESHOLDS.downloadLentaMaxMbps ||
    metrics.latencyMs >= THRESHOLDS.latencyLentaMinMs;
  if (lenta) return "lenta";

  const otima =
    metrics.downloadMbps >= THRESHOLDS.downloadOtimaMinMbps &&
    metrics.jitterMs <= THRESHOLDS.jitterOtimaMaxMs;
  if (otima) return "otima";

  return "instavel";
}

export function montarConclusao(conexao: ConnectionQuality, servidor: ServerHealth): string {
  if (servidor !== "Normal") {
    return "Nosso servidor está mais lento que o normal neste momento. Já estamos cientes e trabalhando nisso — não é a sua internet.";
  }
  if (conexao === "lenta") {
    return "Nosso sistema está funcionando normalmente. A lentidão está na sua conexão de internet neste momento.";
  }
  if (conexao === "instavel") {
    return "Nosso sistema está normal. Sua conexão está oscilando, o que pode causar travamentos em alguns momentos.";
  }
  return "Tudo certo! Sua conexão e o nosso sistema estão funcionando bem.";
}
